import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-button-delete',
  templateUrl: './button-delete.component.html',
  styleUrls: ['./button-delete.component.scss'],
})
export class ButtonDeleteComponent implements OnInit {
  @Output() click = new EventEmitter<void>();

  constructor() {}

  ngOnInit(): void {}
}
